var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shareholders-details-home"},[_c('RkTabs',{attrs:{"options":_vm.options,"shrink":"","slider":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}}),_c('keep-alive',[_c(_vm.component,{tag:"components"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }